<template>
  <div class="full-width">
    <div v-if="isHasLabel" class="d-flex align-center">
      <slot name="label">
        <div class="px-2">{{ label }} </div>
      </slot>
      <div>
        <base-button icon small type-action="add" @click="onAdd"> </base-button>
      </div>
    </div>
    <div>
      <div
        v-for="(model, i) in item"
        :key="i"
        class="d-flex justify-center align-center"
        style="height:50px"
      >
        <div class="flex-grow-0">
          <base-button
            :bindIcon="{ small: true }"
            className="mt-2"
            icon
            small
            type-action="delete"
            @click="onRemove(i)"
          >
          </base-button>
        </div>
        <div class="flex-grow-1 pr-2">
          <slot :index="i" :item="item" name="item">
            <v-text-field
              v-model="item[i]"
              v-bind="attrBind"
              dense
              hide-details
            />
          </slot>
        </div>
      </div>
    </div>

    <div v-if="!isHasLabel">
      <base-button small type-action="add" @click="onAdd"> </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '../base/base-button.vue'
import FieldMixin from './field-mixin'
export default {
  components: {},
  mixins: [FieldMixin],
  props: {
    value: { type: Array, default: () => ({}) },
    defaultValue: { default: '' },
  },
  data: () => ({
    p_form: {},
  }),
  computed: {
    isHasLabel() {
      return this.label || this.$slots['label']
    },
  },
  watch: {},
  methods: {
    onAdd() {
      this.item.push(this.defaultValue)
    },
    onRemove(index) {
      this.item.splice(index, 1)
    },
  },
}
</script>

<style scoped></style>
